import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { InsuranceFlowStatus } from 'src/app/_enums/insurance-flow/insurance-flow-status.enum';
import { ProposalState } from 'src/app/_enums/proposal.enums';
import { ProposalDetails } from 'src/app/_types/proposals.type';
import { SendProposalsModalComponent } from 'src/app/shared/components/view-proposals/send-proposals-modal/send-proposals-modal.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { BaseStepperAction } from '../base-action';

@Component({
  selector: 'app-send-proposals-action',
  standalone: true,
  imports: [
    CommonModule,
    NgbTooltipModule,
    SendProposalsModalComponent,
    IconsModule,
  ],
  templateUrl: './send-proposals.component.html',
})
export class SendProposalsActionComponent extends BaseStepperAction {
  get enabled() {
    return (
      this.proposals?.filter(
        (x) => x.proposalState === ProposalState.PROPOSAL_SAVED
      ).length > 0 &&
      this.state?.insuranceFlowData?.status ===
        InsuranceFlowStatus.PREPARING_OFFERS
    );
  }

  get proposals(): ProposalDetails[] {
    return this.state?.proposals;
  }
}
